module.exports = __webpack_public_path__ + "assets/sentiment_neutral_white.dc1be11d.svg";